/**
 * Progress Service Module
 *
 * Exports the ProgressService singleton for user progress tracking.
 */

import { supabase } from '@/services/database/client';
import { useAuthStore } from '@/stores/authStore';
import { useLearningStore } from '@/stores/learningStore';
import { createAuthStoreAdapter, createLearningStoreAdapter } from '@/services/adapters/store.adapters';
import { ProgressService } from './progress.service';

/**
 * Singleton ProgressService instance
 * Initialized with Supabase client and store adapters
 */
export const progressService = new ProgressService(
  supabase,
  createAuthStoreAdapter(useAuthStore),
  createLearningStoreAdapter(useLearningStore)
);

/**
 * Export class for testing (can mock dependencies)
 */
export { ProgressService };
